module.exports = __webpack_public_path__ + "img/matsuyama.e74b77d4.jpg";